import type { CoreTechProps } from "@/components/ui/core-it-block/types";

export default function CoreTechDesktop(props: CoreTechProps) {
    const { items } = props;

    if (items?.length === 0) return null;

    return (
        <svg
            viewBox="100 150 1150 650"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="w-full h-auto"
        >
            <rect
                x="140.5"
                y="307"
                width="228.707"
                height="124"
                rx="16"
                fill="url(#paint0_linear_4671_31341)"
                fillOpacity="0.1"
            />
            <rect
                x="141"
                y="307.5"
                width="227.707"
                height="123"
                rx="15.5"
                stroke="url(#paint1_linear_4671_31341)"
                strokeOpacity="0.4"
            />
            <foreignObject x="155" y="320" width="200" height="50">
                <div className="text-white break-words text-xl">{items?.[0]?.title}</div>
            </foreignObject>
            <foreignObject x="155" y="360" width="200" height="50">
                <div className="text-[#EBEFF4] break-words">{items?.[0]?.description}</div>
            </foreignObject>

            <rect
                x="140.5"
                y="536"
                width="228.707"
                height="124"
                rx="16"
                fill="url(#paint2_linear_4671_31341)"
                fillOpacity="0.1"
            />
            <rect
                x="141"
                y="536.5"
                width="227.707"
                height="123"
                rx="15.5"
                stroke="url(#paint3_linear_4671_31341)"
                strokeOpacity="0.4"
            />
            <foreignObject x="155" y="550" width="200" height="50">
                <div className="text-white break-words text-xl">{items?.[2]?.title}</div>
            </foreignObject>
            <foreignObject x="155" y="590" width="200" height="50">
                <div className="text-[#EBEFF4] break-words">{items?.[2]?.description}</div>
            </foreignObject>

            <rect
                x="978.793"
                y="307"
                width="228.707"
                height="124"
                rx="16"
                fill="url(#paint4_linear_4671_31341)"
                fillOpacity="0.1"
            />
            <rect
                x="979.293"
                y="307.5"
                width="227.707"
                height="123"
                rx="15.5"
                stroke="url(#paint5_linear_4671_31341)"
                strokeOpacity="0.4"
            />
            <foreignObject x="995" y="320" width="200" height="50">
                <div className="text-white break-words text-xl">{items?.[1]?.title}</div>
            </foreignObject>
            <foreignObject x="995" y="360" width="200" height="50">
                <div className="text-[#EBEFF4] break-words">{items?.[1]?.description}</div>
            </foreignObject>

            <rect
                x="978.793"
                y="536"
                width="228.707"
                height="124"
                rx="16"
                fill="url(#paint6_linear_4671_31341)"
                fillOpacity="0.1"
            />
            <rect
                x="979.293"
                y="536.5"
                width="227.707"
                height="123"
                rx="15.5"
                stroke="url(#paint7_linear_4671_31341)"
                strokeOpacity="0.4"
            />
            <foreignObject x="995" y="550" width="200" height="50">
                <div className="text-white break-words text-xl">{items?.[3].title}</div>
            </foreignObject>
            <foreignObject x="995" y="590" width="200" height="50">
                <div className="text-[#EBEFF4] break-words">{items?.[3].description}</div>
            </foreignObject>

            <path
                d="M598.849 471C598.849 472.473 600.043 473.667 601.516 473.667C602.989 473.667 604.183 472.473 604.183 471C604.183 469.527 602.989 468.333 601.516 468.333C600.043 468.333 598.849 469.527 598.849 471ZM366.54 366C366.54 367.473 367.734 368.667 369.207 368.667C370.68 368.667 371.874 367.473 371.874 366C371.874 364.527 370.68 363.333 369.207 363.333C367.734 363.333 366.54 364.527 366.54 366ZM544.185 446.825L543.991 447.286L544.185 446.825ZM601.516 471L601.71 470.539L544.379 446.365L544.185 446.825L543.991 447.286L601.322 471.461L601.516 471ZM415.098 372.067L415.163 371.572L369.273 365.504L369.207 366L369.141 366.496L415.032 372.563L415.098 372.067ZM497.363 414.26L497.727 413.918C475.911 390.707 446.743 375.747 415.163 371.572L415.098 372.067L415.032 372.563C446.384 376.708 475.34 391.559 496.999 414.603L497.363 414.26ZM544.185 446.825L544.379 446.365C526.734 438.924 510.843 427.872 497.727 413.918L497.363 414.26L496.999 414.603C510.21 428.658 526.217 439.792 543.991 447.286L544.185 446.825Z"
                fill="url(#paint8_linear_4671_31341)"
            />
            <path
                d="M598.849 483C598.849 481.527 600.043 480.333 601.516 480.333C602.989 480.333 604.183 481.527 604.183 483C604.183 484.473 602.989 485.667 601.516 485.667C600.043 485.667 598.849 484.473 598.849 483ZM366.54 588C366.54 586.527 367.734 585.333 369.207 585.333C370.68 585.333 371.874 586.527 371.874 588C371.874 589.473 370.68 590.667 369.207 590.667C367.734 590.667 366.54 589.473 366.54 588ZM601.516 483L601.62 483.489L593.473 485.216L593.369 484.727L593.266 484.237L601.412 482.511L601.516 483ZM397.698 586.335L397.727 586.834L369.236 588.499L369.207 588L369.178 587.501L397.669 585.836L397.698 586.335ZM507.551 533.915L507.92 534.252C479.464 565.496 439.915 584.368 397.727 586.834L397.698 586.335L397.669 585.836C439.596 583.385 478.901 564.629 507.181 533.579L507.551 533.915ZM593.369 484.727L593.473 485.216C560.524 492.199 530.599 509.351 507.92 534.252L507.551 533.915L507.181 533.579C530.001 508.523 560.112 491.264 593.266 484.237L593.369 484.727Z"
                fill="url(#paint9_linear_4671_31341)"
            />
            <path
                d="M749.151 478C749.151 479.473 747.957 480.667 746.484 480.667C745.011 480.667 743.817 479.473 743.817 478C743.817 476.527 745.011 475.333 746.484 475.333C747.957 475.333 749.151 476.527 749.151 478ZM981.46 373C981.46 374.473 980.266 375.667 978.793 375.667C977.32 375.667 976.126 374.473 976.126 373C976.126 371.527 977.32 370.333 978.793 370.333C980.266 370.333 981.46 371.527 981.46 373ZM803.815 453.825L804.009 454.286L803.815 453.825ZM746.484 478L746.29 477.539L803.621 453.365L803.815 453.825L804.009 454.286L746.678 478.461L746.484 478ZM932.902 379.067L932.837 378.572L978.727 372.504L978.793 373L978.859 373.496L932.968 379.563L932.902 379.067ZM850.637 421.26L850.273 420.918C872.089 397.707 901.257 382.747 932.837 378.572L932.902 379.067L932.968 379.563C901.616 383.708 872.66 398.559 851.001 421.603L850.637 421.26ZM803.815 453.825L803.621 453.365C821.266 445.924 837.157 434.872 850.273 420.918L850.637 421.26L851.001 421.603C837.79 435.658 821.783 446.792 804.009 454.286L803.815 453.825Z"
                fill="url(#paint10_linear_4671_31341)"
            />
            <path
                d="M976.126 590C976.126 591.473 977.32 592.667 978.793 592.667C980.266 592.667 981.46 591.473 981.46 590C981.46 588.527 980.266 587.333 978.793 587.333C977.32 587.333 976.126 588.527 976.126 590ZM745.618 485C745.618 486.473 746.812 487.667 748.285 487.667C749.758 487.667 750.952 486.473 750.952 485C750.952 483.527 749.758 482.333 748.285 482.333C746.812 482.333 745.618 483.527 745.618 485ZM847.684 534.691L847.323 535.037L847.684 534.691ZM978.793 590L978.884 589.508L935.585 581.518L935.494 582.01L935.403 582.501L978.702 590.492L978.793 590ZM762.639 487.907L762.738 487.417L748.384 484.51L748.285 485L748.186 485.49L762.54 488.397L762.639 487.907ZM847.684 534.691L848.045 534.344C825.051 510.381 795.289 494.009 762.738 487.417L762.639 487.907L762.54 488.397C794.891 494.949 824.47 511.22 847.323 535.037L847.684 534.691ZM935.494 582.01L935.585 581.518C902.183 575.354 871.561 558.853 848.045 534.344L847.684 534.691L847.323 535.037C870.985 559.696 901.795 576.299 935.403 582.501L935.494 582.01Z"
                fill="url(#paint11_linear_4671_31341)"
            />

            <g filter="url(#filter0_f_4671_31341)">
                <circle cx="682.625" cy="482.122" r="56.3217" fill="#89BCED" fillOpacity="0.7" />
            </g>

            <g filter="url(#filter1_f_4671_31341)">
                <ellipse cx="682" cy="483.5" rx="260" ry="120" fill="#157DB3" fillOpacity="0.4" />
            </g>

            <path
                d="M731.333 443.264C731.333 443.847 731.225 444.398 731.009 444.895C730.793 445.402 730.502 445.834 730.134 446.212C729.756 446.59 729.324 446.882 728.817 447.098C728.309 447.314 727.769 447.422 727.186 447.422C726.581 447.422 726.03 447.314 725.534 447.109C725.037 446.904 724.605 446.612 724.238 446.245C723.87 445.878 723.59 445.435 723.395 444.938C723.19 444.43 723.082 443.89 723.082 443.286C723.082 442.702 723.19 442.152 723.406 441.655C723.622 441.147 723.914 440.715 724.281 440.337C724.659 439.959 725.091 439.678 725.598 439.462C726.106 439.246 726.646 439.138 727.229 439.138C727.834 439.138 728.385 439.246 728.882 439.452C729.378 439.657 729.81 439.948 730.178 440.316C730.545 440.683 730.826 441.126 731.02 441.622C731.247 442.119 731.333 442.67 731.333 443.264ZM730.534 443.329C730.534 442.8 730.458 442.335 730.275 441.903C730.113 441.471 729.875 441.115 729.594 440.802C729.303 440.488 728.946 440.262 728.547 440.1C728.147 439.938 727.715 439.862 727.24 439.862C726.743 439.862 726.29 439.959 725.868 440.132C725.447 440.316 725.102 440.564 724.821 440.866C724.529 441.18 724.313 441.536 724.151 441.946C723.989 442.346 723.914 442.778 723.914 443.242C723.914 443.772 723.989 444.236 724.173 444.668C724.335 445.1 724.572 445.456 724.853 445.77C725.145 446.083 725.501 446.31 725.89 446.472C726.29 446.634 726.722 446.709 727.197 446.709C727.704 446.709 728.169 446.612 728.568 446.439C728.99 446.266 729.335 446.007 729.616 445.705C729.908 445.392 730.124 445.035 730.286 444.625C730.448 444.214 730.534 443.782 730.534 443.329ZM729.141 445.359C729.141 445.381 729.141 445.413 729.13 445.435C729.119 445.456 729.108 445.478 729.065 445.489C729.022 445.5 728.968 445.5 728.903 445.51C728.838 445.521 728.741 445.521 728.622 445.521C728.514 445.521 728.439 445.521 728.363 445.51C728.298 445.5 728.244 445.5 728.19 445.467C728.147 445.456 728.115 445.424 728.082 445.402C728.05 445.381 728.039 445.338 728.028 445.284L727.791 444.506C727.694 444.214 727.575 444.009 727.445 443.901C727.316 443.782 727.1 443.728 726.83 443.728H726.516V445.348C726.516 445.413 726.495 445.456 726.441 445.5C726.387 445.521 726.268 445.543 726.063 445.543C725.858 445.543 725.728 445.532 725.674 445.5C725.62 445.478 725.598 445.424 725.598 445.348V441.331C725.598 441.201 725.642 441.093 725.706 440.996C725.771 440.92 725.879 440.877 726.03 440.877H727.197C727.51 440.877 727.758 440.899 727.985 440.953C728.201 441.007 728.385 441.104 728.536 441.212C728.687 441.32 728.795 441.471 728.86 441.633C728.925 441.795 728.968 441.979 728.968 442.184C728.968 442.53 728.871 442.821 728.687 443.005C728.504 443.188 728.244 443.329 727.92 443.404C728.093 443.458 728.255 443.566 728.406 443.696C728.558 443.847 728.687 444.042 728.806 444.333L729.087 445.068C729.119 445.24 729.141 445.327 729.141 445.359ZM727.931 442.281C727.931 442.206 727.92 442.108 727.888 442.044C727.866 441.968 727.823 441.892 727.758 441.838C727.694 441.784 727.607 441.73 727.488 441.709C727.38 441.687 727.229 441.655 727.056 441.655H726.506V442.983H727.035C727.37 442.983 727.618 442.918 727.737 442.8C727.866 442.659 727.931 442.497 727.931 442.281Z"
                fill="white"
            />
            <path
                d="M697.314 507.243L682.993 515.516V498.916L697.314 490.643V507.243Z"
                fill="white"
            />
            <path
                d="M668.672 507.243L682.993 515.516V498.916L668.672 490.643V507.243Z"
                fill="white"
            />
            <path
                d="M697.314 527.353L682.982 535.626V519.026L697.314 510.764V527.353Z"
                fill="white"
            />
            <path
                d="M668.661 527.353L682.982 535.626V519.026L668.661 510.764V527.353Z"
                fill="white"
            />
            <path d="M697.314 437.273L682.982 429V445.6L697.314 453.862V437.273Z" fill="white" />
            <path d="M668.661 437.273L682.982 429V445.6L668.661 453.862V437.273Z" fill="white" />
            <path
                d="M729.077 492.479V509.014L714.702 500.72V484.185L729.077 492.479Z"
                fill="white"
            />
            <path
                d="M714.756 517.287L729.076 509.014L714.702 500.72L700.381 508.982L714.756 517.287Z"
                fill="white"
            />
            <path
                d="M697.368 457.542L711.689 465.814L697.314 474.109L682.993 465.847L697.368 457.542Z"
                fill="white"
            />
            <path
                d="M711.688 482.349V465.814L697.313 474.109V490.643L711.688 482.349Z"
                fill="white"
            />
            <path
                d="M714.777 447.465L729.098 455.727L714.723 464.032L700.402 455.759L714.777 447.465Z"
                fill="white"
            />
            <path
                d="M729.098 472.273V455.727L714.724 464.032V480.567L729.098 472.273Z"
                fill="white"
            />
            <path
                d="M636.909 492.479V509.014L651.284 500.72V484.185L636.909 492.479Z"
                fill="white"
            />
            <path
                d="M651.23 517.287L636.909 509.014L651.284 500.72L665.605 508.982L651.23 517.287Z"
                fill="white"
            />
            <path
                d="M668.618 457.542L654.297 465.814L668.672 474.109L682.992 465.847L668.618 457.542Z"
                fill="white"
            />
            <path
                d="M654.297 482.349V465.814L668.672 474.109V490.643L654.297 482.349Z"
                fill="white"
            />
            <path
                d="M651.208 447.465L636.888 455.727L651.262 464.032L665.583 455.759L651.208 447.465Z"
                fill="white"
            />
            <path
                d="M636.888 472.273V455.727L651.262 464.032V480.567L636.888 472.273Z"
                fill="white"
            />

            <defs>
                <filter
                    id="filter0_f_4671_31341"
                    x="526.304"
                    y="325.8"
                    width="312.644"
                    height="312.643"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="BackgroundImageFix"
                        result="shape"
                    />
                    <feGaussianBlur stdDeviation="50" result="effect1_foregroundBlur_4671_31341" />
                </filter>

                <filter
                    id="filter1_f_4671_31341"
                    x="-50%"
                    y="-50%"
                    width="200%"
                    height="200%"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="BackgroundImageFix"
                        result="shape"
                    />
                    <feGaussianBlur stdDeviation="80" result="effect1_foregroundBlur_4671_31341" />
                </filter>

                <linearGradient
                    id="paint0_linear_4671_31341"
                    x1="231.539"
                    y1="245"
                    x2="373.82"
                    y2="348.637"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#4E9BBF" />
                    <stop offset="0.529973" stopColor="#4E9BBF" stopOpacity="0.6" />
                    <stop offset="1" stopColor="#4E9BBF" />
                </linearGradient>
                <linearGradient
                    id="paint1_linear_4671_31341"
                    x1="207.114"
                    y1="218.043"
                    x2="405.474"
                    y2="295.958"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#4E9BBF" />
                    <stop offset="0.192167" stopColor="#4E9BBF" stopOpacity="0" />
                    <stop offset="0.767991" stopColor="#4E9BBF" stopOpacity="0" />
                    <stop offset="1" stopColor="#4E9BBF" />
                </linearGradient>
                <linearGradient
                    id="paint2_linear_4671_31341"
                    x1="231.539"
                    y1="474"
                    x2="373.82"
                    y2="577.637"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#4E9BBF" />
                    <stop offset="0.529973" stopColor="#4E9BBF" stopOpacity="0.6" />
                    <stop offset="1" stopColor="#4E9BBF" />
                </linearGradient>
                <linearGradient
                    id="paint3_linear_4671_31341"
                    x1="207.114"
                    y1="447.043"
                    x2="405.474"
                    y2="524.958"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#4E9BBF" />
                    <stop offset="0.192167" stopColor="#4E9BBF" stopOpacity="0" />
                    <stop offset="0.767991" stopColor="#4E9BBF" stopOpacity="0" />
                    <stop offset="1" stopColor="#4E9BBF" />
                </linearGradient>
                <linearGradient
                    id="paint4_linear_4671_31341"
                    x1="1069.83"
                    y1="245"
                    x2="1212.11"
                    y2="348.637"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#4E9BBF" />
                    <stop offset="0.529973" stopColor="#4E9BBF" stopOpacity="0.6" />
                    <stop offset="1" stopColor="#4E9BBF" />
                </linearGradient>
                <linearGradient
                    id="paint5_linear_4671_31341"
                    x1="1045.41"
                    y1="218.043"
                    x2="1243.77"
                    y2="295.958"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#4E9BBF" />
                    <stop offset="0.192167" stopColor="#4E9BBF" stopOpacity="0" />
                    <stop offset="0.767991" stopColor="#4E9BBF" stopOpacity="0" />
                    <stop offset="1" stopColor="#4E9BBF" />
                </linearGradient>
                <linearGradient
                    id="paint6_linear_4671_31341"
                    x1="1069.83"
                    y1="474"
                    x2="1212.11"
                    y2="577.637"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#4E9BBF" />
                    <stop offset="0.529973" stopColor="#4E9BBF" stopOpacity="0.6" />
                    <stop offset="1" stopColor="#4E9BBF" />
                </linearGradient>
                <linearGradient
                    id="paint7_linear_4671_31341"
                    x1="1045.41"
                    y1="447.043"
                    x2="1243.77"
                    y2="524.958"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#4E9BBF" />
                    <stop offset="0.192167" stopColor="#4E9BBF" stopOpacity="0" />
                    <stop offset="0.767991" stopColor="#4E9BBF" stopOpacity="0" />
                    <stop offset="1" stopColor="#4E9BBF" />
                </linearGradient>
                <linearGradient
                    id="paint8_linear_4671_31341"
                    x1="601.516"
                    y1="471"
                    x2="372.02"
                    y2="376.271"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#020506" />
                    <stop offset="1" stopColor="#89BCED" />
                </linearGradient>
                <linearGradient
                    id="paint9_linear_4671_31341"
                    x1="601.516"
                    y1="483"
                    x2="372.02"
                    y2="577.729"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#020506" />
                    <stop offset="1" stopColor="#89BCED" />
                </linearGradient>
                <linearGradient
                    id="paint10_linear_4671_31341"
                    x1="746.484"
                    y1="478"
                    x2="975.98"
                    y2="383.271"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#020506" />
                    <stop offset="1" stopColor="#89BCED" />
                </linearGradient>
                <linearGradient
                    id="paint11_linear_4671_31341"
                    x1="978.793"
                    y1="590"
                    x2="750.563"
                    y2="496.524"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#89BCED" />
                    <stop offset="1" stopColor="#020506" />
                </linearGradient>
            </defs>
        </svg>
    );
}
